import React from 'react'
import Layout from '../components/Layout/layout'
import Seo from '../components/seo'
import StrapiPageSection from '../components/Layout/Section/StrapiPageSection'
import {graphql} from 'gatsby'
import getStrapiPageMeta from '../helpers/getStrapiPageMeta'

const IndexPage = ({data}) => {
    const meta = getStrapiPageMeta(data.strapiPage.meta)

    return (
        <Layout>
            <Seo {...meta} />
            <StrapiPageSection page={data.strapiPage} />
        </Layout>
    )
}

export default IndexPage

export const pageQuery = graphql`
    query ($language: String!) {
        strapiPage(helper_name: {eq: "Strona główna"}, locale: {eq: $language}) {
            ...PageFragment
        }
        locales: allLocale(filter: {language: {eq: $language}}) {
            ...LanguageFragment
        }
    }
`
